export default __webpack_public_path__ + "static/media/sticker-A.d3dfe419.png";